export default __webpack_public_path__ + "static/media/otel.f623e3ec.png";